import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { StationAudiosListPage } from './StationAudiosListPage';

/**
 * Wraps the audios list page in the audit station layout for station-scoped audit routes.
 */
export function AuditAudiosPageAdapter() {
  return (
    <AuditStationPage>
      <StationAudiosListPage />
    </AuditStationPage>
  );
}
